/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const importTeamSearchResultSchema = z.object({
  imported: z.boolean(),
  name: z.string(),
  sourceId: z.string(),
});
